module.exports = __webpack_public_path__ + "img/property.b0131d75.png";